<template>
  <NetworkStatus v-if="isOffline" />
  <div v-else>
    <main>
      <div class="container-fluid">
        <!-- Header section with background image -->
        <div
          class="page-header min-height-300"
          style="
            background-image: url(&quot;https://images.unsplash.com/photo-1531512073830-ba890ca4eba2?ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&ixlib=rb-1.2.1&auto=format&fit=crop&w=1920&q=80&quot;);
          "
        >
        </div>

        <!-- Profile header card -->
        <div class="card shadow-lg header-profile mt-n6">
          <div class="card-body p-3">
            <div class="row gx-4 ">
             <div class="col-md-6 d-flex align-items-center">
  <div class="profile-img-container me-3">
    <img
      v-if="studentDetails.photo_url"
      :src="studentDetails.photo_url"
      class="profile-img border-2 border-white"
      alt="Student Photo"
    />
    <img
      v-else
      src="@/assets/img/no_body.jpg"
      class="profile-img border-2 border-white"
      alt="Student Photo"
    />
  </div>
  <div class="profile-name-container" style="position: relative; bottom: -10px;">
    <h6 class="text-uppercase fw-bold fs-3 mt-4 ps-3 profile-name" style="width: 500px;">
      {{ studentDetails.first_name }}
      
    </h6>
    <h6 class="text-uppercase fw-bold fs-3 mt-4 ps-3 profile-name" style="width: 500px; position: relative; bottom: 20px; ">
      {{ studentDetails.last_name }}
    </h6>
  </div>
</div>

              <div class="col-md-6 pt-7">
                <div class="row">
                  <div class="col-6">
                    <h6 class="text-uppercase text-sm mt-4">
                    </h6>
                  </div>
                  <div class="col-6 text-end px-0">
                    <argon-button
                      color="danger"
                      variant="gradient"
                      style="height: 50px; padding-top: 15px; width: 150px"
                      data-bs-toggle="modal"
                      data-bs-target="#staticBackdrop13"
                    >
                      {{ $t("button.delete") }}
                    </argon-button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Main content section -->
        <div class="py-4 container-fluid">
          <div class="row">
            <div class="col-md-8">
              <div class="card pb-4">
                <div class="card-body">
                  <!-- Spinner de chargement initial seulement -->
                  <div
                    v-if="initialLoading"
                    class="text-center mt-8 mb-8"
                    style="height: 200px"
                  >
                    <div>
                      <span class="mt-4">
                        <Spinner></Spinner>
                      </span>
                    </div>
                  </div>

                  <div class="" v-else-if="studentDetails">
                    <div class="row">
                      <div class="col-md-6">
                        <label class="form-control-label">{{
                          $t("students_detail.number")
                        }}</label>
                        <argon-input
                          type="text"
                          v-model="studentDetails.registration_number"
                        />
                      </div>

                      <div class="col-md-6">
                        <label class="form-control-label">{{
                          $t("students_detail.last_name")
                        }}</label>
                        <argon-input
                          type="text"
                          v-model="studentDetails.first_name"
                        />
                      </div>

                      <div class="col-md-6">
                        <label class="form-control-label">{{
                          $t("students_detail.first_name")
                        }}</label>
                        <argon-input
                          type="text"
                          v-model="studentDetails.last_name"
                        />
                      </div>

                      <!-- Enhanced phone input section -->
                      <div class="col-md-6">
                        <label class="form-control-label">{{
                          $t("students_detail.sexe")
                        }}</label>
                        <div class="d-flex">
                          <div class="form-check">
                            <input
                              class="form-check-input"
                              type="radio"
                              value="M"
                              v-model="studentDetails.gender"
                              id="maleRadio"
                            />
                            <label class="form-check-label" for="maleRadio">{{
                              $t("students_detail.M")
                            }}</label>
                          </div>
                          <div class="form-check mx-4">
                            <input
                              class="form-check-input"
                              type="radio"
                              value="F"
                              v-model="studentDetails.gender"
                              id="femaleRadio"
                            />
                            <label class="form-check-label" for="femaleRadio">{{
                              $t("students_detail.F")
                            }}</label>
                          </div>
                        </div>
                      </div>

                      <div class="col-md-6 mt-3">
                        <label class="form-control-label">{{
                          $t("students_detail.place_birth")
                        }}</label>
                        <argon-input type="text" v-model="studentDetails.pob" />
                      </div>

                      <div class="col-md-6 mt-3">
                        <label class="form-control-label">{{
                          $t("students_detail.date")
                        }}</label>
                        <argon-input type="date" v-model="studentDetails.dob" />
                      </div>

                      <div class="col-md-12">
                        <label class="form-control-label">{{
                          $t("students_detail.phone")
                        }}</label>
                        <div
                          class="tag-input"
                          :class="{ required: phoneValidationMessage }"
                          style="min-height: 40px"
                        >
                          <div
                            v-for="(tag, index) in tags"
                            :key="index"
                            class="tag-input__tag"
                            :title="
                              tag.is_on_eska
                                ? $t('messages.number_on_eska')
                                : $t('messages.number_not_on_eska')
                            "
                            :style="{
                              backgroundColor: tag.is_on_eska
                                ? '#2980b9'
                                : '#2980b9',
                              opacity: tag.is_on_eska ? '1' : '0.8',
                              cursor: tag.is_on_eska ? 'pointer' : 'pointer',
                            }"
                          >
                            <img
                              style="transform: translateY(-1px)"
                              v-if="tag.is_on_eska"
                              src="@/assets/img/eska.png"
                              class="eska-tag-logo me-1"
                              alt="Eska"
                            />
                            <i
                              v-else
                              class="bi bi-question-circle-fill me-1"
                            ></i>
                            {{ tag.number }}
                            <span
                              class="ms-2 text-danger"
                              @click="removeTag(index)"
                              ><i class="fa fa-close"></i
                            ></span>
                          </div>
                          <div class="d-flex align-items-center">
                            <input
                              type="text"
                              :placeholder="
                                $t('new_student.placeholder_number')
                              "
                              class="tag-input__text"
                              @keydown="checkKey"
                              @keypress="validateNumber"
                              :disabled="isCheckingNumber"
                              autocomplete="off"
                            />
                            <div
                              v-if="isCheckingNumber"
                              class="spinner-border spinner-border-sm ms-2"
                              role="status"
                            >
                              <span class="visually-hidden">Loading...</span>
                            </div>
                          </div>
                        </div>
                        <span
                          v-if="phoneValidationMessage"
                          class="validation-message"
                          >{{ phoneValidationMessage }}</span
                        >
                        <span v-else style="font-size: 12px">{{
                          $t("students_detail.phone_text")
                        }}</span>
                      </div>
                    </div>
                    <div class="col-6 mt-4">
                      <argon-button
                        :loading="saveLoading"
                        :color="hasChanges ? 'success' : 'secondary'"
                        :disabled="!hasChanges || saveLoading"
                        full-width
                        @click="saveChanges"
                        style="height: 50px; padding-top: 15px"
                      >
                        {{ $t("button.save") }}
                      </argon-button>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="col-md-4 d-flex flex-column">
              <todo-list-card
                :total-due="studentDetails.total_due"
                :current_payment="studentDetails.current_payment"
                :payment_status="studentDetails.payment_status"
                :students="studentDetails.payments"
                :studentDetails="studentDetails"
                :classroom="studentClassroom"
              >
                <template #footer>
                  <div class="d-flex justify-content-center pt-3" v-if="certificateReady">
                    <argon-button
                      color="success"
                      variant="outline"
                      style="height: 50px; padding-top: 15px; width: 100%; min-width: 286px"
                      @click="requestCertificate"
                    >
                      <i class="bi bi-award me-1"></i>
                      {{ $t("button.generate_certificate") }}
                    </argon-button>
                  </div>
                </template>
              </todo-list-card>
            </div>
          </div>
        </div>
      </div>

      <!-- Delete Modal -->
      <div
        class="modal fade"
        id="staticBackdrop13"
        data-bs-backdrop="static"
        data-bs-keyboard="false"
        tabindex="-1"
        aria-labelledby="staticBackdropLabel"
        aria-hidden="true"
      >
        <div class="modal-dialog">
          <div class="card">
            <div class="modal-content">
              <div class="modal-header border-0">
                <h5 class="modal-title" id="staticBackdropLabel3"></h5>
                <button
                  type="button"
                  class="btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                ></button>
              </div>
              <div class="modal-body mt-n3 text-center pt-4 pb-4">
                <i
                  class="bi bi-exclamation-triangle-fill text-warning fs-2 mb-3"
                ></i>
                <div class="content1" v-if="!cannotDeleteStudent">
                  <h6>{{ $t("students_detail.modal_delete_title") }}</h6>
                  <p class="px-6">
                    {{ $t("students_detail.modal_delete_text") }}
                  </p>
                </div>
                <div class="content1" v-if="cannotDeleteStudent">
                  <h6>{{ $t("students_detail.modal_no_delete_title") }}</h6>
                  <p class="px-6">
                    {{ $t("students_detail.modal_no_delete_text") }}
                  </p>
                </div>
              </div>
                            <div class="modal-footer border-0 pb-5 mb-1">
                <argon-button
                  v-if="!cannotDeleteStudent"
                  type="button"
                  class="btn bg-transparent border"
                  data-bs-dismiss="modal"
                  style="width: 150px; height: 50px; padding-top: 15px"
                >
                  {{ $t("button.cancel") }}
                </argon-button>
                <argon-button
                  v-if="!cannotDeleteStudent"
                  :loading="deleteLoading"
                  color="danger"
                  variant="gradient"
                  type="button"
                  class="mt-1"
                  style="
                    width: 150px;
                    height: 50px;
                    padding-top: 15px;
                    margin-right: 60px;
                  "
                  @click="deleteStudent"
                >
                  {{ $t("button.confirm") }}
                </argon-button>
                
                <argon-button
                  v-if="cannotDeleteStudent"
                  type="button"
                  class="btn bg-transparent border"
                  data-bs-dismiss="modal"
                  style="
                    width: 150px;
                    height: 50px;
                    padding-top: 15px;
                    margin-right: 60px;
                  "
                >
                  {{ $t("button.close") }}
                </argon-button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </main>
  </div>

  <!-- Certificat de scolarité de cet élève uniquement -->
  <!--
    Avertissement affiché UNIQUEMENT pour un élève dont la scolarité n'est pas
    réglée. L'établissement autorise la délivrance, mais l'administrateur doit
    être informé : on demande donc une confirmation explicite plutôt que de
    générer en silence.
  -->
  <div class="cert-warning-overlay" v-if="showUnpaidWarning" @click.self="cancelCertificate">
    <div class="cert-warning-modal">
      <div class="cert-warning-icon">
        <i class="bi bi-exclamation-triangle-fill"></i>
      </div>
      <h6 class="mb-2" style="text-align: center;">{{ $t("certificate_warning.title") }}</h6>
      <p class="text-sm mb-1">
        {{ $t("certificate_warning.text", { name: studentFullName }) }}
      </p>
      <p class="text-sm mb-0" style="opacity: 0.7">
        {{ $t("certificate_warning.notice") }}
      </p>
      <div class="d-flex justify-content-end gap-2 mt-4">
        <button type="button" class="btn-ghost" @click="cancelCertificate">
          {{ $t("button.cancel") }}
        </button>
        <button type="button" class="btn-confirm" @click="confirmCertificate">
          {{ $t("certificate_warning.confirm") }}
        </button>
      </div>
    </div>
  </div>

  <certificate-generator
    :open="showCertificate"
    :students="certificateStudents"
    :classroom="studentClassroom"
    @close="showCertificate = false"
  />
</template>

<script>
import { canIssueCertificate } from "@/utils/classroomSetup";
import CertificateGenerator from "@/views/Classroom/CertificateGenerator.vue";
import {
  deleteStudent,
  updateStudent,
  getStudent,
  getchecknumberEska,
  getStudentClassrooms,
} from "@/utils/services";
import ArgonButton from "@/components/ArgonButton";
import ArgonInput from "@/components/ArgonInput.vue";
import TodoListCard from "@/views/components/TodoListCard";
import Spinner from "../components/Spinner.vue";
import { toast } from "vue3-toastify";
import "vue3-toastify/dist/index.css";
import { isOfflineError } from "@/utils/network";
import NetworkStatus from "@/views/components/NetworkStatus.vue";
import api_config from "@/config";

export default {
  name: "student-profile",
  components: { TodoListCard, ArgonInput, ArgonButton, Spinner, NetworkStatus, CertificateGenerator },

  data() {
    return {
      studentDetails: {},
      showCertificate: false,
      /* Avertissement préalable pour un élève non à jour de sa scolarité. */
      showUnpaidWarning: false,
      // Classe réelle de l'élève : /api/student/:id ne renvoie pas le niveau,
      // on le récupère via /api/get_classroom_details pour que la variable
      // {{classe}} du certificat contienne la vraie valeur et non un blanc.
      studentClassroom: { grade_code: "", speciality_code: "", name: "", number: "" },
      initialLoading: false, // Pour le chargement initial des données
      saveLoading: false,    // Pour le bouton de sauvegarde
      deleteLoading: false,  // Pour le bouton de suppression
      buttonActive: false,
      showConfirmation: false,
      phoneValidationMessage: "",
      isCheckingNumber: false,
      originalDetails: {},
      tags: [],
      eska: false,
      originalTags: [],
      isOffline: false,
      apiError: false,
      phone_prefix: api_config.PHONE_PREFIX,
      phone_max_length: api_config.PHONE_MAX_LENGTH,
      intervalId: null,
    };
  },

  computed: {
    /**
     * Mêmes conditions que dans la liste des élèves, via le même helper :
     * mode collaboratif, certificat configuré, et élève éligible selon le
     * réglage « Autoriser les certificats pour tous les élèves ».
     */
    certificateReady() {
      return canIssueCertificate(this.studentDetails);
    },
    /** Vrai si la scolarité de l'élève est intégralement réglée. */
    /**
     * L'élève a-t-il réglé TOUTES les tranches qui lui sont attribuées ?
     *
     * On s'appuie sur les tranches elles-mêmes plutôt que sur
     * `payment_status`, qui est un statut global calculé côté serveur et ne
     * dit pas si chaque échéance est soldée. Les autres paiements
     * (`is_other_payment`) sont exclus : ils ne relèvent pas de la scolarité.
     *
     * Un élève sans aucune tranche n'est PAS considéré comme réglé : c'est le
     * cas d'une classe sans groupe de paiement appliqué, où rien n'a encore
     * été versé.
     */
    isSettled() {
      const installments = (this.studentDetails.payments || []).filter(
        (payment) => payment && payment.is_other_payment !== true
      );
      if (!installments.length) return false;
      return installments.every(
        (payment) => String(payment.status || "").toLowerCase() === "settled"
      );
    },
    studentFullName() {
      const s = this.studentDetails || {};
      return [s.first_name, s.last_name].filter(Boolean).join(" ");
    },
    /**
     * Le générateur attend une liste : on lui passe cet unique élève, avec
     * ses données réelles telles que renvoyées par /api/student/:id.
     */
    certificateStudents() {
      return this.studentDetails && this.studentDetails.registration_number
        ? [this.studentDetails]
        : [];
    },
    parsedPhoneList() {
      if (this.studentDetails.phone_list) {
        const fixedJson = this.studentDetails.phone_list
          .replace(/'/g, '"')
          .replace(/True/g, "true")
          .replace(/False/g, "false");
        return JSON.parse(fixedJson);
      }
      return [];
    },
    hasChanges() {
      const detailsChanged =
        JSON.stringify(this.getComparableDetails(this.studentDetails)) !==
        JSON.stringify(this.getComparableDetails(this.originalDetails));

      const tagsChanged =
        JSON.stringify(this.tags) !== JSON.stringify(this.originalTags);

      return detailsChanged || tagsChanged;
    },
    cannotDeleteStudent() {
      return (this.studentDetails.payments || []).some(
        (p) => p.status !== null
      );
    },
  },

  watch: {
    // Supprimer le watch sur loading car on a maintenant des loading séparés
    saveLoading(newVal) {
      console.log('Save loading changed:', newVal);
      if (!newVal) {
        this.$nextTick(() => {
          this.unlockScroll();
        });
      }
    },
    
    deleteLoading(newVal) {
      console.log('Delete loading changed:', newVal);
      if (!newVal) {
        this.$nextTick(() => {
          this.unlockScroll();
        });
      }
    }
  },

  async mounted() {
    this.unlockScroll();

    window.addEventListener("online", this.updateOnlineStatus);
    window.addEventListener("offline", this.updateOnlineStatus);

    console.log("StudentProfile mounted: Starting initial online status check and data load.");
    
    await this.updateOnlineStatus(); 

    if (!this.isOffline) {
      const studentIdFromRoute = this.$route.params.id;
      if (studentIdFromRoute) {
        console.log("StudentProfile mounted: studentId found in route, loading details for:", studentIdFromRoute);
        await this.loadStudentDetails(studentIdFromRoute);
      } else {
        console.error("StudentProfile mounted: studentId NOT found in route params. Cannot load student details.");
        this.initialLoading = false;
        toast.error(this.$t("messages.error.missing_student_id") || "ID de l'étudiant manquant pour charger le profil.");
        this.apiError = true;
        this.isOffline = true;
      }
    }

    console.log("StudentProfile mounted: Setting up periodic online status update.");
    this.intervalId = setInterval(this.updateOnlineStatus, 10000); 

    this.$nextTick(() => {
      this.unlockScroll();
    });
  },

  beforeUnmount() {
    window.removeEventListener("online", this.updateOnlineStatus);
    window.removeEventListener("offline", this.updateOnlineStatus);

    if (this.intervalId) {
      clearInterval(this.intervalId);
    }
    
    this.unlockScroll();
  },

  methods: {
    /**
     * Ouvre le certificat, après confirmation si l'élève n'est pas à jour.
     *
     * L'avertissement ne concerne QUE ce cas : pour un élève réglé, le
     * document s'ouvre directement, sans étape supplémentaire.
     */
    requestCertificate() {
      if (this.isSettled) {
        this.showCertificate = true;
        return;
      }
      this.showUnpaidWarning = true;
    },
    cancelCertificate() {
      this.showUnpaidWarning = false;
    },
    confirmCertificate() {
      this.showUnpaidWarning = false;
      this.showCertificate = true;
      // TODO backend : notifier l'administrateur de l'établissement.
      // Aucun endpoint n'est exposé à ce jour ; l'appel viendra ici.
    },
    /**
     * Récupère la classe réelle de l'élève (niveau + spécialité) auprès de
     * /api/get_classroom_details. C'est cette donnée — et non une supposition
     * faite sur la fiche élève — qui alimente la variable {{classe}} du
     * certificat. En cas d'échec on laisse la valeur vide : le générateur
     * signalera alors la donnée manquante au lieu d'imprimer un faux.
     */
    async loadStudentClassroom() {
      const classroomId = this.$route.params.classroom_id;
      if (!classroomId) return;
      try {
        const res = await getStudentClassrooms({ classroom_id: classroomId });
        const classroom = (res && res.data && res.data.classroom) || {};
        this.studentClassroom = {
          grade_code: classroom.grade_code || "",
          speciality_code: classroom.speciality_code || "",
          // Nom lisible du niveau (« 5ème »), affiché sur le reçu à la place
          // du code interne (« CIN ») ; `grade_code` reste transmis pour le
          // certificat, qui s'appuie dessus.
          name: (classroom.grade && classroom.grade.name) || classroom.name || "",
          // Numéro de la salle (« BC ») : le reçu compose « 5ème BC / TI »,
          // comme l'en-tête de la fiche de classe.
          number: classroom.number || "",
        };
      } catch (error) {
        console.error("Failed to load student classroom", error);
      }
    },

    unlockScroll() {
      try {
        document.body.style.overflow = 'auto';
        document.documentElement.style.overflow = 'auto';
        document.body.style.height = 'auto';
        document.documentElement.style.height = 'auto';
        document.body.style.position = 'static';
        document.documentElement.style.position = 'static';
        
        document.body.classList.remove('modal-open', 'overflow-hidden');
        document.documentElement.classList.remove('modal-open', 'overflow-hidden');
      } catch (error) {
        console.error("Error unlocking scroll:", error);
      }
    },

    checkScrollIssues() {
      console.log('Body overflow:', getComputedStyle(document.body).overflow);
      console.log('HTML overflow:', getComputedStyle(document.documentElement).overflow);
      console.log('Body height:', getComputedStyle(document.body).height);
      console.log('Scroll height:', document.body.scrollHeight);
      console.log('Client height:', document.body.clientHeight);
      console.log('Body classes:', document.body.className);
      console.log('HTML classes:', document.documentElement.className);
    },

    async updateOnlineStatus() {
      const studentId = this.studentDetails.id || this.$route.params.id;
      if (navigator.onLine) {
        try {
          if (studentId) {
            await this.checkConnection(studentId);
            this.isOffline = this.apiError;
          } else {
            this.isOffline = false; 
          }
        } catch (error) {
          console.error("updateOnlineStatus: Error during API connection check:", error);
          this.isOffline = true;
        }
      } else {
        this.isOffline = true;
      }
    },

    async checkConnection(studentId) {
      try {
        if (!studentId) {
          console.warn("checkConnection: Called without studentId. Cannot check API.");
          this.apiError = true;
          return;
        }
        await getStudent(studentId);
        this.apiError = false; 
      } catch (error) {
        console.error("checkConnection: API Error for studentId", studentId, ":", error);
        this.apiError = true; 
      }
    },

    close() {
      this.eska = false;
    },

    validateNumber(event) {
      const charCode = event.which ? event.which : event.keyCode;
      if (charCode > 31 && (charCode < 48 || charCode > 57)) {
        event.preventDefault();
        return false;
      }
      return true;
    },

    getComparableDetails(details) {
      if (!details) return {};
      return {
        registration_number: details.registration_number,
        last_name: details.last_name,
        first_name: details.first_name,
        gender: details.gender,
        pob: details.pob,
        dob: details.dob,
      };
    },

    async checkKey(event) {
      if (
        event.key === "Enter" ||
        event.key === " " ||
        event.key === "," ||
        event.key === ";"
      ) {
        event.preventDefault();
        let val = event.target.value.trim();

        if (!/^\d+$/.test(val)) {
          toast.error(this.$t("new_student.only_numbers"));
          return;
        }

        if (val.length > 0) {
          if (!val.startsWith(this.phone_prefix)) {
            val = this.phone_prefix + val;
          }

          if (val.length !== this.phone_max_length + this.phone_prefix.length) {
            toast.error(this.$t("new_student.invalid_phone_lengt"));
            return;
          }

          const numberExists = this.tags.some((tag) => tag.number === val);
          if (numberExists) {
            toast.error(this.$t("new_student.number_already_exists"), {
              autoClose: 3000,
            });
            event.target.value = "";
            return;
          }

          try {
            this.isCheckingNumber = true;
            const response = await getchecknumberEska({
              number_list: [val],
            });

            if (response.available?.includes(val)) {
              this.tags.push({
                number: val,
                is_on_eska: true,
              });
              this.eska = false;
            } else {
              this.tags.push({
                number: val,
                is_on_eska: false,
              });
              this.eska = true;
            }
            event.target.value = "";
            this.phoneValidationMessage = "";
          } catch (error) {
            console.error("Error checking number:", error);
            toast.error(this.$t("new_student.error_checking_number"));
          } finally {
            this.isCheckingNumber = false;
          }
        }
      }
    },

    async loadStudentDetails(studentIdFromRoute) {
      if (!studentIdFromRoute) {
        console.error("loadStudentDetails: Aborted because studentIdFromRoute is missing.");
        this.initialLoading = false;
        toast.error(this.$t("messages.error.missing_student_id_for_load") || "ID étudiant manquant pour le chargement.");
        return;
      }
      
      try {
        this.initialLoading = true; // Utiliser initialLoading pour le chargement des données
        console.log("loadStudentDetails: Fetching details for studentId:", studentIdFromRoute);
        this.studentDetails = await getStudent(studentIdFromRoute);
        console.log("loadStudentDetails: Student details fetched:", JSON.parse(JSON.stringify(this.studentDetails)));

        this.originalDetails = JSON.parse(JSON.stringify(this.studentDetails));

        // La classe n'est pas incluse dans /api/student/:id : on la charge à
        // part, sans bloquer l'affichage de la fiche si l'appel échoue.
        this.loadStudentClassroom();

        if (this.studentDetails.phone_list && typeof this.studentDetails.phone_list === 'string') {
          try {
            const fixedJson = this.studentDetails.phone_list
              .replace(/'/g, '"')
              .replace(/True/g, "true")
              .replace(/False/g, "false");
            this.tags = JSON.parse(fixedJson);
            this.originalTags = JSON.parse(JSON.stringify(this.tags));
            console.log("loadStudentDetails: Parsed phone_list into tags:", this.tags);
          } catch (e) {
            console.error("loadStudentDetails: Error parsing phone_list JSON.", "Value:", this.studentDetails.phone_list, "Error:", e);
            this.tags = [];
            this.originalTags = [];
            toast.error(this.$t("messages.error.parsing_phone_list_failed") || "Erreur d'analyse de la liste de téléphones.");
          }
        } else {
          this.tags = [];
          this.originalTags = [];
          if (Object.prototype.hasOwnProperty.call(this.studentDetails, 'phone_list') && this.studentDetails.phone_list !== null) {
            console.warn("loadStudentDetails: phone_list is present but not a string or is null:", this.studentDetails.phone_list);
          } else {
            console.log("loadStudentDetails: No phone_list found or it's null/empty.");
          }
        }

        this.$nextTick(() => {
          this.unlockScroll();
        });

      } catch (error) {
        console.error("loadStudentDetails: General error loading student details for studentId", studentIdFromRoute, ":", error);
        /*
         * Coupure réseau : la carte « pas de connexion » est déjà à l'écran,
         * posée par l'intercepteur axios. Un « échec du chargement » par-dessus
         * désignerait les données alors que seul le réseau manque.
         */
        if (!isOfflineError(error)) {
          toast.error(this.$t("messages.error.load_failed") || "Échec du chargement des détails de l'étudiant.");
        }
        this.apiError = true;
        this.isOffline = true;
      } finally {
        this.initialLoading = false; // Arrêter le loading initial
        this.$nextTick(() => {
          this.unlockScroll();
        });
      }
    },

    removeTag(index) {
      this.tags.splice(index, 1);
    },

    async saveChanges() {
      // Empêcher les clics multiples
      if (this.saveLoading) {
        console.log("saveChanges: Already saving, ignoring click");
        return;
      }

      try {
        console.log("saveChanges: Starting save process");
        this.saveLoading = true; // Activer le loading du bouton

        // Validation des champs
        if (this.tags.length === 0) {
          this.phoneValidationMessage = this.$t("new_student.required_field");
          return; // Le finally se chargera de désactiver le loading
        }

        // Préparation des données
        const updatedStudent = {
          ...this.studentDetails,
          phone_list: JSON.stringify(this.tags),
        };

        console.log("saveChanges: Calling API with data:", updatedStudent);
        
        // Appel API
        const response = await updateStudent(updatedStudent.id, updatedStudent);

        if (response) {
          toast.success(this.$t("students_detail.update_success"));
          console.log("saveChanges: Update successful. Reloading details for studentId:", updatedStudent.id);
          
          // Recharger les détails (sans affecter le saveLoading)
          await this.loadStudentDetails(updatedStudent.id);
        }
            } catch (error) {
        console.error("saveChanges: Error updating student:", error);
        toast.error(this.$t("messages.update_failed") || "Échec de la mise à jour.");
      } finally {
        console.log("saveChanges: Ending save process");
        this.saveLoading = false; // Désactiver le loading du bouton
        this.$nextTick(() => {
          this.unlockScroll();
        });
      }
    },

    async deleteStudent() {
      // Empêcher les clics multiples
      if (this.deleteLoading) {
        console.log("deleteStudent: Already deleting, ignoring click");
        return;
      }

      try {
        console.log("deleteStudent: Starting delete process for studentId:", this.studentDetails.id);
        this.deleteLoading = true; // Activer le loading du bouton de suppression
        
        await deleteStudent(this.studentDetails.id);
        toast.success(this.$t("students_detail.delete_success"));
        console.log("deleteStudent: Deletion successful. Closing modal and navigating to class-details for classroom_id:", this.$route.params.classroom_id);
        
        // Fermer le modal proprement
        const modal = document.getElementById('staticBackdrop13');
        const modalInstance = window.bootstrap?.Modal?.getInstance(modal);
        if (modalInstance) {
          modalInstance.hide();
        }
        
        this.$nextTick(() => {
          // Supprimer tous les overlays de modal
          const overlays = document.querySelectorAll('.modal-backdrop');
          overlays.forEach(overlay => overlay.remove());
          
          // Nettoyer les classes du body
          document.body.classList.remove('modal-open');
          document.body.style.overflow = '';
          document.body.style.paddingRight = '';
          
          // Rediriger après nettoyage
          this.$router.push({
            name: "class-details",
            params: { classId: this.$route.params.classroom_id },
          });
        });
        
      } catch (error) {
        console.error("deleteStudent: Error deleting student:", error);
        toast.error(this.$t("messages.error.delete_failed") || "Échec de la suppression.");
      } finally {
        console.log("deleteStudent: Ending delete process");
        this.deleteLoading = false; 
        this.$nextTick(() => {
          this.unlockScroll();
        });
      }
    },
  },
};
</script>

<style scoped>
.header-profile {
  background: transparent !important;
}

.argon-button:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.no-click {
  pointer-events: none;
}

.tag-input {
  width: 100%;
  background: transparent;
  border: 1px solid rgba(250, 250, 250, 0.4);
  border-radius: 10px;
  font-size: 0.9em;
  padding: 10px;
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}

.tag-input__tag {
  display: inline-flex;
  align-items: center;
  height: 30px;
  color: white;
  font-size: 14px;
  border-radius: 15px;
  padding: 0 8px;
  margin: 2px;
}

.tag-input__text {
  flex: 1;
  min-width: 420px;
  height: 30px;
  border: none;
  outline: none;
  font-size: 1em;
  background: none;
  color: white;
}

.eska-tag-logo {
  width: 16px;
  height: 16px;
  object-fit: contain;
  vertical-align: middle;
  border-radius: 50%;
}

.bi-question-circle-fill {
  font-size: 14px;
  color: white;
}

.validation-message {
  font-size: 0.875rem;
  color: #f13939;
  font-weight: 500;
}

.tag-input.required {
  border: 2px solid #f13939 !important;
  animation: shake 0.5s;
}

@keyframes shake {
  0%,
  100% {
    transform: translateX(0);
  }

  25% {
    transform: translateX(-5px);
  }

  75% {
    transform: translateX(5px);
  }
}

.input-size-45 {
  height: 45px;
  font-size: 16px;
}

body, html {
  overflow: auto !important;
  height: auto !important;
}

.container-fluid {
  overflow: visible;
  height: auto;
}

.page-header {
  overflow: visible;
}

.header-profile {
  background: transparent !important;
}

.tag-input__text {
  flex: 1;
  min-width: 200px; 
  height: 30px;
  border: none;
  outline: none;
  font-size: 1em;
  background: none;
  color: white;
}

.modal {
  overflow-y: auto;
}
.profile-img-container {
  min-width: 254px;
  max-width: 254px;
  min-height: 254px;
  max-height: 254px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  border-style: solid;
  border-radius: 50%;
  border-width: 5px;
}

.profile-img {
  width: 250px;
  height: 250px;
  border-radius: 50%;
  object-fit: cover;
  background: #222;
}

.profile-name-container {
  flex: 1;
  min-width: 0;
  /* Pour éviter que le texte ne pousse l'image */
}



/* --- Avertissement scolarité non réglée --------------------------------- */

.cert-warning-overlay {
  position: fixed;
  inset: 0;
  z-index: 1080;
  background: rgba(8, 12, 24, 0.72);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px;
}

.cert-warning-modal {
  width: 100%;
  max-width: 460px;
  background: #141a2f;
  color: #e6ebf5;
  border: 1px solid rgba(255, 255, 255, 0.12);
  border-radius: 14px;
  padding: 26px;
  box-shadow: 0 24px 60px -20px rgba(0, 0, 0, 0.7);
  text-align: left;
}

.cert-warning-icon {
  font-size: 30px;
  color: #fbbf24;
  margin-bottom: 10px;
  text-align: center;
}

.btn-ghost {
  border-radius: 9px;
  border: 1px solid rgba(255, 255, 255, 0.16);
  background: transparent;
  color: inherit;
  font-size: 13px;
  padding: 9px 16px;
  cursor: pointer;
}

.btn-confirm {
  border: none;
  border-radius: 9px;
  background: #fbbf24;
  color: #2a1e00;
  font-size: 13px;
  font-weight: 600;
  padding: 9px 18px;
  cursor: pointer;
}

.btn-confirm:hover {
  opacity: 0.9;
}

</style>


